import { createFileRoute } from "@tanstack/react-router";
import { Editor } from "./tools.blog.$id";

export const Route = createFileRoute("/tools/blog/new")({
  head: () => ({
    meta: [{ title: "New blog post" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: () => <Editor mode={{ kind: "new" }} />,
});
